
import  { default as indexLang } from '../english/indexLang';
import  { default as table } from '../english/table';
import  { default as placeholder } from '../english/placeholder';
import  { default as button } from '../english/button';
import  { default as dialog } from '../english/dialog';
import  { default as home } from '../english/home';
import  { default as other } from '../english/other';
import  { default as withdraw } from '../english/withdraw';

export default {
    indexLang,
    table,
    placeholder,
    button,
    dialog,
    home,
    other,
    withdraw
}



// WEBPACK FOOTER //
// ./src/i18n/english/index.js